import { TrackingEvent } from '@y42/user-tracking-legacy';

export class SignedInTrackingEvent extends TrackingEvent {
  readonly name = 'SignedIn';
}
